import { useCallback } from 'react'
import create from 'zustand'

type EmarsysStore = {
  scriptIsLoaded: boolean
  setScriptIsLoaded: () => void
  scarabQueueIsLoaded: boolean
  setScarabQueueIsLoaded: () => void
  featuredProducts?: string[]
  relatedProducts?: string[]
  recommendedProducts?: string[]
  setProductIds: (type: 'featured' | 'related' | 'recommended', ids: string[]) => void
}

const useStore = create<EmarsysStore>((set) => ({
  scriptIsLoaded: false,
  setScriptIsLoaded: () => set({ scriptIsLoaded: true }),
  scarabQueueIsLoaded: false,
  setScarabQueueIsLoaded: () => set({ scarabQueueIsLoaded: true }),
  featuredProducts: null,
  relatedProducts: null,
  recommendedProducts: null,
  setProductIds: (type, ids) => {
    if (type === 'featured') {
      set({
        featuredProducts: ids,
      })
    }
    if (type === 'related') {
      set({
        relatedProducts: ids,
      })
    }
    set({
      recommendedProducts: ids,
    })
  },
}))

export function useEmarsys() {
  return useStore()
}

export function useSetEmarsysStore() {
  const setScriptIsLoaded = useStore((state) => state.setScriptIsLoaded)
  const setScarabQueueIsLoaded = useStore((state) => state.setScarabQueueIsLoaded)
  const setProductIds = useStore((state) => state.setProductIds)

  const set = useCallback((updates: Partial<EmarsysStore>) => {
    useStore.setState(updates as any)
  }, [])

  return {
    setScriptIsLoaded,
    setScarabQueueIsLoaded,
    setProductIds,
    set,
  }
}

// Individual getters
export function useEmarsysScriptIsLoaded() {
  return useStore((state) => state.scriptIsLoaded)
}

export function useEmarsysScarabQueueIsLoaded() {
  return useStore((state) => state.scarabQueueIsLoaded)
}

export function useEmarsysFeaturedProducts() {
  return useStore((state) => state.featuredProducts)
}

export function useEmarsysRelatedProducts() {
  return useStore((state) => state.relatedProducts)
}

export function useEmarsysRecommendedProducts() {
  return useStore((state) => state.recommendedProducts)
}
